import { CompendiumPage } from "./pages/CompendiumPage";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { TimelineSpinner } from "./components/timeline/TimelineSpinner";
import { BookPage } from "./pages/BookPage";
import { CharacterPage } from "./pages/CharacterPage";
import { LegalPage } from "./pages/LegalPage";
import { LandingPage } from "./pages/LandingPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { BookTimelinePage } from "./pages/BookTimelinePage";
import { SeriesPage } from "./pages/SeriesPage";
import { StatusPage } from "./pages/StatusPage";

const CharacterAdminPage = import.meta.env.DEV
  ? lazy(() => import("./pages/CharacterAdminPage"))
  : null;

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<LandingPage />} />
          {/* Open on every environment, but only linked from the homepage outside production. */}
          <Route path="status" element={<StatusPage />} />
          <Route path="legal" element={<LegalPage />} />
          {CharacterAdminPage !== null ? (
            <Route
              path="admin"
              element={
                <Suspense fallback={<TimelineSpinner label="Loading…" page />}>
                  <CharacterAdminPage />
                </Suspense>
              }
            />
          ) : null}
          <Route path=":seriesSlug" element={<SeriesPage />} />
          <Route path=":seriesSlug/characters/:characterId" element={<CharacterPage />} />
          <Route path=":seriesSlug/races/:entryId" element={<CompendiumPage kind="race" />} />
          <Route path=":seriesSlug/vehicles/:entryId" element={<CompendiumPage kind="vehicle" />} />
          <Route
            path=":seriesSlug/businesses/:entryId"
            element={<CompendiumPage kind="business" />}
          />
          <Route
            path=":seriesSlug/organizations/:entryId"
            element={<CompendiumPage kind="organization" />}
          />
          <Route path=":seriesSlug/spells/:entryId" element={<CompendiumPage kind="spell" />} />
          <Route path=":seriesSlug/morphs/:entryId" element={<CompendiumPage kind="morph" />} />
          <Route path=":seriesSlug/items/:entryId" element={<CompendiumPage kind="item" />} />
          <Route path=":seriesSlug/:bookSlug" element={<BookPage />} />
          <Route path=":seriesSlug/:bookSlug/play" element={<BookTimelinePage />} />
          <Route path=":seriesSlug/:bookSlug/:chapterSlug" element={<BookTimelinePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
